import { fetchDataFailureVPO, fetchDataSuccessVPO } from "./actions";
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import { FetchRequestAction } from "../../types/strapiVPO";
import { extractStrapiData, getData } from '../../api/api';

export function* fetchDataSagaVPO(action: FetchRequestAction) {
  const { modelName, params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(getData, modelName, params);
    const extractedData = extractStrapiData(response);
    const paginationInfo = response.data?.meta?.pagination;
    yield put(fetchDataSuccessVPO(modelName, extractedData, paginationInfo));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(fetchDataFailureVPO(modelName, errorMessage));
  }
}